module.exports = __webpack_public_path__ + "static/media/surface-5.3596b367.png";